import React, {Component} from 'react';
import Modal from '../Modal';
import styled from 'styled-components';
import {BODY_TEXT_COLOR, THIRD_COLOR, ACCENT_COLOR} from '../../config/colors'
import {HeaderDiv, TextDiv} from '../../modals';

export default class KioskDisabledModal extends Component {
  isNextBtnClicked: false;
  modalStyle = {border: '3px solid ' + ACCENT_COLOR};

  render() {
    return (
      <Modal

        style={this.modalStyle}
        overlayTop={0}
        paddingTop={200}
        closeOnOutsideClick={false}
        isOpened={true}>
        <ModalWrapperDiv>
          <div>
            <HeaderDiv color={BODY_TEXT_COLOR}>ERROR</HeaderDiv>
            <TextDiv>Kiosk is not enabled</TextDiv>
          </div>
        </ModalWrapperDiv>
      </Modal>
    );
  }
}

const ModalWrapperDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;



// WEBPACK FOOTER //
// ./src/components/KioskDisabledModal/KioskDisabledModal.jsx